import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDot = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 4,
	height: 4,
	viewBox: "0 0 4 4",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 2,
		cy: 2,
		r: 1.5,
		fill: "#6B719D"
	})
});
export default SvgDot;
